import DownloadIcon from '@mui/icons-material/Download'
import { Stack } from '@mui/material'
import { useDownloadDocumentFromAzureStorage } from '@src/data/api/merchants-api/merchants-api'

interface Props {
  fileName: string
  sasTokenUrl: string
}

const DownloadButton = ({ fileName, sasTokenUrl }: Props) => {
  const [downloadDocument] = useDownloadDocumentFromAzureStorage()

  const handleDownload = async () => {
    try {
      await downloadDocument({ fileName, sasTokenUrl })
    } catch (error) {
      console.error('Failed to download document:', error)
    }
  }

  return (
    <Stack direction="row" marginTop="-0.5rem" justifyContent="center">
      <DownloadIcon sx={{ color: 'grey', cursor: 'pointer' }} onClick={handleDownload} />
    </Stack>
  )
}

export default DownloadButton
